import *  as axios from 'axios';
import * as ActionTypes from '../../constants/actiontypes/backoffice/clients';
import * as ActionTypesAuth from '../../constants/actiontypes/auth';
import * as urls from '../../constants/webapi/backoffice/clients';
import * as authUrls from '../../constants/webapi/auth';
import * as R from 'ramda';
import { getAuthenticationUrl } from '../../constants/webapi/auth';
import * as ActionTypesClients from '../../constants/actiontypes/backoffice/clients';
import * as userUrls from '../../constants/webapi/user';


export function fetchAllClients(pageNumber, searchTerm, roles, sortByTerm, sortDesc) {
    const page = parseInt(pageNumber);
    if (!R.isNil(pageNumber) && isNaN(page)) {
        throw new Error("pageNumber must be null or an integer");
    }
    pageNumber -= 1;

    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_CLIENTS_REQUEST });
        return axios.get(urls.usersByUrl(pageNumber, searchTerm, roles, sortByTerm, sortDesc))
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_CLIENTS_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {

                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_CLIENTS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function fetchAllClientsData() {
    return new Promise((resolve, reject) => {
        axios.get(urls.usersByUrlData())
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }

                throw error.statusText;
            });
    });
}

export function fetchAllClientsDataState() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_ALL_CLIENTS_DATA_REQUEST });
        return axios.get(urls.usersByUrlData())
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_ALL_CLIENTS_DATA_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_ALL_CLIENTS_DATA_FAILURE,
                    error: error.response
                });
                throw error;
            });
    };
}

export function deleteClient(user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesClients.DELETE_CLIENT_REQUEST, user: user });
        return axios.delete(userUrls.userByIdUrl(user.id))
            .then((response) => {
                dispatch({
                    type: ActionTypesClients.DELETE_CLIENT_SUCCESS,
                    data: response.data,
                    user: user
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesClients.DELETE_CLIENT_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function updateClient(userId, user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesClients.UPDATE_CLIENT_REQUEST, user: userId });
        return axios.put(userUrls.userByIdUrl(userId), user)
            .then((response) => {
                dispatch({
                    type: ActionTypesClients.UPDATE_CLIENT_SUCCESS,
                    data: response.data,
                    user: user,
                    userId: userId
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesClients.UPDATE_CLIENT_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function updateClientSecurity(userId, user) {
    return (dispatch) => {
        dispatch({ type: ActionTypesClients.UPDATE_CLIENT_SECURITY_REQUEST, user: userId });
        return axios.put(userUrls.userSecurityByIdUrl(userId), user)
            .then((response) => {
                dispatch({
                    type: ActionTypesClients.UPDATE_CLIENT_SECURITY_SUCCESS,
                    data: response.data,
                    user: user,
                    userId: userId
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypesClients.UPDATE_CLIENT_SECURITY_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function resetPassword(email, phoneNumber) {
    return (dispatch) => {
        dispatch({ type: ActionTypesAuth.RESET_PASSWORD_REQUEST });
        return axios.post(authUrls.resetPasswordEmail(), { email, phoneNumber })
            .then(() => {
                dispatch({
                    type: ActionTypesAuth.RESET_PASSWORD_SUCCESS
                });
            })
            .catch((error) => {
                dispatch({
                    type: ActionTypesAuth.RESET_PASSWORD_FAILURE,
                    error: error.response
                });
                throw error;
            });
    };
}

export function setFilterGlobal(filter) {

    return {
        type: ActionTypes.SET_CLIENT_FILTER,
        data: filter
    };

}